// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oo0-","top":"styles_top__3IONv"};